import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
     setOrder,
     setSelectedRow,
     onUpdateColumn
} from '../../../store/fuerzaventas/listarproductos/actions';
import { sort_by} from '../../../helpers/commons'

import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column'
    }, 
    tableWrap: {
        flex: '1 1 auto'
    }
}));

const ListarProductosList = () => {
    const classes = useStyles();
    const columns = useSelector(state => state.listarproductos.table.columns);
    const loadingStore = useSelector(state => state.listarproductos.store.loading);
    const order = useSelector(state => state.listarproductos.table.order);
    const orderBy = useSelector(state => state.listarproductos.table.orderBy);
    const store = useSelector(state => state.listarproductos.store);
    const dispatch = useDispatch();


    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
        let homes = store.data;
        homes.sort(sort_by(property, isAsc, homes[0][property]));
    };

    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column))
    }

    return (
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
            <div className={classes.tableWrap}>
                <Table
                    columns={columns}
                    count={store.total}
                    loading={loadingStore}
                    onRowClick={items => {}}
                    onRowDoubleClick={() => {}}
                    onSort={datakey => handleRequestSort(datakey)}
                    onUpdateColumn={handleResizeColumn}
                    rowCount={store.data.length}
                    rowGetter={index =>  store.data[index] }
                    rowsPerPage={store.pageSize}
                    selected={store.selected}
                    sortBy={orderBy}
                    sortDirection={order}
                />
            </div>
        </FieldSet>
    )
};

export default ListarProductosList;